import React from 'react';

export const ChartPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { type, data, labels, title } = specificAttrs || {};
  const dataArray = (data || '10,20,30,40').split(',').map(Number);
  const labelsArray = (labels || 'A,B,C,D').split(',');
  const maxValue = Math.max(...dataArray);
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{
        padding: '16px',
        background: '#FFFFFF',
        border: '1px solid #E5E7EB',
        borderRadius: '8px'
      }}>
      {title && <h4 style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: '600' }}>{title}</h4>}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', height: '150px' }}>
        {dataArray.map((value, idx) => (
          <div key={idx} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{
              width: '100%',
              height: `${(value / maxValue) * 100}%`,
              background: type === 'line' ? '#3B82F6' : '#10B981',
              borderRadius: '4px 4px 0 0',
              minHeight: '10px'
            }} />
            <span style={{ fontSize: '11px', marginTop: '4px', color: '#6B7280' }}>
              {labelsArray[idx]?.trim() || idx + 1}
            </span>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};
